import { Link } from "react-router-dom";
import { formatZAR } from "@/lib/api";

export default function ProductCard({ product, index = 0 }) {
  if (!product) return null;
  return (
    <Link
      to={`/products/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block fade-up"
      style={{ animationDelay: `${Math.min(index, 6) * 60}ms` }}
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-nude rounded-2xl">
        <img
          src={product.image}
          alt={product.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        {product.badges?.[0] && (
          <span className="absolute top-3 left-3 bg-ivory/90 backdrop-blur text-[10px] uppercase tracking-luxe px-2.5 py-1 rounded-full border border-stone-line">
            {product.badges[0]}
          </span>
        )}
        {product.compare_at_price && product.compare_at_price > product.price && (
          <span className="absolute top-3 right-3 bg-charcoal text-ivory text-[10px] uppercase tracking-luxe px-2.5 py-1 rounded-full">
            Save R{(product.compare_at_price - product.price).toLocaleString("en-ZA")}
          </span>
        )}
      </div>
      <div className="mt-4 px-1">
        <p className="small-label">{product.texture} · {product.length_inches}″</p>
        <h3 className="font-serif text-lg mt-1 leading-tight">{product.title}</h3>
        <div className="mt-2 flex items-baseline gap-2">
          <span className="text-sm font-medium" data-testid={`product-price-${product.slug}`}>{formatZAR(product.price)}</span>
          {product.compare_at_price && product.compare_at_price > product.price && (
            <span className="text-xs text-stone line-through">{formatZAR(product.compare_at_price)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
